<template>
    <article :class="{'campus-event': true, 'campus-event--active':isActive}" :id="`event-${event.campusEventId}`" ref="event">
        <div class="campus-event__province">
            <span class="province__in">IN: </span>
            <span class="province__name" v-text="event.province.name" :style="{color: event.province.color}"></span>
        </div>

        <h2 class="campus-event__title">
            <span>{{ event.title }}</span>
        </h2>

        <div class="campus-event__date">
            <span class="campus-event__date-label">Date: </span>
            <span class="campus-event__date-value">{{ date }}</span>
        </div>

        <div class="campus-event__time">
            <span class="campus-event__time-label">Time: </span>
            <span class="campus-event__time-value">{{ time }}</span>
        </div>

        <div class="campus-event__time">
            <span class="campus-event__time-label">Location: </span>
            <span class="campus-event__time-value">{{ event.location }}</span>
        </div>

        <div class="campus-event__description" v-html="event.description"></div>

        <div class="campus-event__color-bar" :style="{backgroundColor: event.province.color}"></div>
    </article>
</template>

<script>
import moment from 'moment'
// import EventSlugManager from "@/services/EventSlugManager";
import {gsap} from "gsap";

export default {
    name: "CampusEvent",
    props: ['event', 'isActive'],

    computed: {

        // url() {
        //     const slug = EventSlugManager.slugFor(this.event)
        //     return `https://discoveryourpurple.com/campus-resources/campus-events/${slug}`
        // },

        datetime() {
            return moment(this.event.datetime)
        },

        date() {
            const date = this.datetime.format('MMMM Do, YYYY')
            return `${date}`
        },

        time() {
            return `${this.datetime.format('h:mm a')} ${this.event.timezone}`
        }
    },

    mounted() {
        if (this.isActive) {
            gsap.to( document.body, {
                scrollTop: this.$refs.event.offsetTop - 30,
                duration: .5,
                ease: 'expo',

            })
        }
    }
}
</script>
